import { Typography } from "@mui/material";
import React from "react";

export default function TextBankInfoValue({ children, ...props }) {
  return (
    <Typography
      {...props}
      sx={{
        display: "-webkit-box",
        overflow: "hidden",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 1, 
      }}
      variant="caption"
      fontWeight={500}
      color="rgba(15, 23, 42, 1)"
    >
      {children}
    </Typography>
  );
}
